// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"styles_m-1480__NzGoZ","page":"styles_page__raIZH","content":"styles_content__eWsF4"};